import { MODAL } from '../actions/modals';

export const InitialState = {
  isActive: false,
  typeModal: null,
  modalInfo: null
};

// REDUCERS
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = InitialState, action) {
  switch (action.type) {
    case MODAL.CHANGE_STATUS:
      return Object.assign({}, state, {
        isActive: action.status
      });

    case MODAL.CHANGE_TYPE:
      return Object.assign({}, state, {
        typeModal: action.modal
      });

    case MODAL.SAVE_INFO:
      return Object.assign({}, state, {
        modalInfo: action.info
      });

    case MODAL.DELETE_INFO:
      return Object.assign({}, state, {
        modalInfo: null
      });

    default:
      return state
  }
}